<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M4.5 0.75C5.61933 0.75 6.56613 1.48584 6.88477 2.5H10.875C12.6009 2.5 14 3.89911 14 5.625C14 7.35089 12.6009 8.75 10.875 8.75H5.125C4.22754 8.75 3.5 9.47754 3.5 10.375C3.5 11.2725 4.22754 12 5.125 12H9.11523C9.43387 10.9858 10.3807 10.25 11.5 10.25C12.8807 10.25 14 11.3693 14 12.75C14 14.1307 12.8807 15.25 11.5 15.25C10.3807 15.25 9.43387 14.5142 9.11523 13.5H5.125C3.39911 13.5 2 12.1009 2 10.375C2 8.64911 3.39911 7.25 5.125 7.25H10.875C11.7725 7.25 12.5 6.52246 12.5 5.625C12.5 4.72754 11.7725 4 10.875 4H6.88477C6.56613 5.01416 5.61933 5.75 4.5 5.75C3.11929 5.75 2 4.63071 2 3.25C2 1.86929 3.11929 0.75 4.5 0.75ZM11.5 11.75C10.9477 11.75 10.5 12.1977 10.5 12.75C10.5 13.3023 10.9477 13.75 11.5 13.75C12.0523 13.75 12.5 13.3023 12.5 12.75C12.5 12.1977 12.0523 11.75 11.5 11.75ZM4.5 2.25C3.94772 2.25 3.5 2.69772 3.5 3.25C3.5 3.80228 3.94772 4.25 4.5 4.25C5.05228 4.25 5.5 3.80228 5.5 3.25C5.5 2.69772 5.05228 2.25 4.5 2.25Z"
    fill="currentColor"
  />
</svg>
